// import getThemeClampValues from './helpers/themeClamps';
document.addEventListener('DOMContentLoaded', function () {
    // const fontSizes = [
    //   {
    //     name: 'CMS Elements Bottom',
    //     min: 2,
    //     max: 5,
    //   },
    //   // {
    //   //   name: 'Quote pull up',
    //   //   min: 14,
    //   //   max: 30,
    //   // },
    //   // {
    //   //   name: 'Video Logo Inset',
    //   //   min: 1,
    //   //   max: 6,
    //   // },
    //   // {
    //   //   name: 'Column Y Offset',
    //   //   min: 10,
    //   //   max: 20,
    //   // },
    //   // {
    //   //   name: 'Accordion Column Y',
    //   //   min: 1.5,
    //   //   max: 3,
    //   // },
    //   // {
    //   //   name: 'Block Inner Y',
    //   //   min: 5,
    //   //   max: 18,
    //   // },
    //   // {
    //   //   name: 'Play Button',
    //   //   min: 7,
    //   //   max: 15,
    //   // },
    //   // {
    //   //   name: 'Hero Y',
    //   //   min: 17,
    //   //   max: 34,
    //   // },
    //   // {
    //   //   name: 'Footer Content Y',
    //   //   min: 4,
    //   //   max: 9,
    //   // },
    //   // {
    //   //   name: 'Grid Gutter',
    //   //   min: 3,
    //   //   max: 6,
    //   // },
    //   // {
    //   //   name: 'Container Gutter',
    //   //   min: 9,
    //   //   max: 18,
    //   // },
    //   // {
    //   //   name: 'Region Select Y',
    //   //   min: 5,
    //   //   max: 15,
    //   // },
    //   // {
    //   //   name: 'Region Item Y',
    //   //   min: 1.5,
    //   //   max: 2.5,
    //   // },
    //   // {
    //   //   name: 'Region Select Y',
    //   //   min: 5,
    //   //   max: 15,
    //   // },
    //   // {
    //   //   name: 'Block Title X',
    //   //   min: 2,
    //   //   max: 4,
    //   // },
    //   // {
    //   //   name: 'Block Title Y',
    //   //   min: 2,
    //   //   max: 3,
    //   // },
    //   // {
    //   //   name: 'Button',
    //   //   min: 1.6,
    //   //   max: 3,
    //   // },
    //   // {
    //   //   name: 'Title - XL - Tailwind 6XL',
    //   //   min: 5.8,
    //   //   max: 12,
    //   // },
    //   // {
    //   //   name: 'Title - LG - Tailwind 5XL',
    //   //   min: 3.4,
    //   //   max: 7,
    //   // },
    //   // {
    //   //   name: 'Title - MD - Tailwind 4XL',
    //   //   min: 1.6,
    //   //   max: 4.2,
    //   // },
    //   // {
    //   //   name: 'Title - SM - Tailwind 3XL',
    //   //   min: 1.6,
    //   //   max: 3.6,
    //   // },
    //   // {
    //   //   name: 'Paragraph - XL - Tailwind 2XL',
    //   //   min: 1.6,
    //   //   max: 3.2,
    //   // },
    //   // {
    //   //   name: 'Title - XS - - Tailwind XL',
    //   //   min: 1.4,
    //   //   max: 2.8,
    //   // },
    //   // {
    //   //   name: 'Paragraph - LG - Tailwind LG',
    //   //   min: 1.4,
    //   //   max: 2.4,
    //   // },
    //   // {
    //   //   name: 'Paragraph - MD - Tailwind MD',
    //   //   min: 1.4,
    //   //   max: 1.8,
    //   // },
    // ];
    // getThemeClampValues(fontSizes);
});
